// eslint-disable-next-line max-len
const PROVIDERS_REGEXP = /(booking|expedia|google|Hertz|rentalcars|Rentalcars|SIXT|agoda|traveloka|ctrip|Ctrip|booking_cug|booking_cug1|booking_cug2|booking_cug3|booking_mobile_app|expedia_mobile_app|makemytrip|hilton|brand)/;

export default PROVIDERS_REGEXP;
